import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logout-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button 
      class="logout-button" 
      (click)="logout()"
      *ngIf="isUserLoggedIn">
      Logout
    </button>
  `,
  styles: [`
    :host {
      display: contents;
    }

    .logout-button {
      height: 30px;
      padding: 0 13px;
      background: var(--ap-danger-soft, #FEE2E2);
      color: var(--ap-danger, #B42318);
      border: none;
      border-radius: var(--ap-radius-sm, 6px);
      font-size: 12px;
      font-weight: 550;
      cursor: pointer;
      transition: background 0.15s, color 0.15s;
      white-space: nowrap;
      width: auto;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .logout-button:hover {
      background: var(--ap-danger, #B42318);
      color: #fff;
    }

    @media (max-width: 768px) {
      .logout-button {
        height: 38px;
        font-size: 13px;
        flex: 1;
      }
    }
  `]
})
export class LogoutButtonComponent implements OnInit, OnDestroy {
  isUserLoggedIn: boolean = false;
  private authSubscription: Subscription | null = null;
  
  constructor(public authService: AuthService) {}
  
  ngOnInit(): void {
    // Check initial state
    this.isUserLoggedIn = this.authService.isLoggedIn;
    
    // Subscribe to user changes to update the button visibility
    this.authSubscription = this.authService.currentUser$.subscribe(user => {
      this.isUserLoggedIn = !!user;
    });
  }
  
  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
      this.authSubscription = null;
    }
  }
  
  logout(): void {
    this.authService.logout();
  }
}
